import { useWorkspaceStore } from '@/stores/useWorkspaceStore';
import { watch } from 'vue';

export const updateHtmlLangPlugin = () => {
  const workspaceStore = useWorkspaceStore();

  const updateHtmlLang = () => (document.documentElement.lang = workspaceStore.currentLocale);

  watch(
    () => workspaceStore.currentLocale,
    () => updateHtmlLang()
  );

  updateHtmlLang();
};
